export enum Permission {
    NotSet = 0,
    Allow = 1,
    Deny = 2,
}